const lastLoginKey = 'lokalbank-web:last-login-time';

const useLastShowLogin = () => {
    return window.sessionStorage?.getItem(lastLoginKey);
};

export const setLastShownLogin = (lastLogin: string) => {
    window.sessionStorage?.setItem(lastLoginKey, lastLogin);
};

export default useLastShowLogin;
